<template>
    <v-container class="component_main px-6">
        <v-row class="px-0 py-0 my-0">
            <v-col cols="8" class="py-0">
                <h1>Acompanhamento de Envio</h1>
                <p class="mb-0">Recurso de Glosas - acompanhamento de envio {{envio_manual? ' manual':' automático'}}</p>
            </v-col>
            <v-col cols="4" class="text-right">
                <v-btn
                    outlined
                    small
                    height="32px"
                    color="primary"
                    class="px-2 ml-0"
                    depressed
                    @click="$router.go(-1)"
                    ><v-icon small class="pr-2">fa-reply</v-icon> voltar</v-btn
                >
            </v-col>
        </v-row>
        <v-row class="py-0 text-right">
            <v-col class="py-0" >
                <span class="py-0" v-if="tipo_protocolo == 'pagamento' && protocolo_pagamento && protocolo_pagamento.data_envio">Recurso enviado em <b style="font-size: 1.2em">{{protocolo_pagamento.data_envio | formatDate}}</b> -</span><span class="pr-2 py-0" v-if="tipo_protocolo == 'pagamento' && protocolo_pagamento && protocolo_pagamento.numero_protocolo_envio"> Protocolo nº <b style="font-size: 1.2em">{{protocolo_pagamento.numero_protocolo_envio}}</b></span>
            </v-col>
        </v-row>
        <v-row
            class="ma-0 pl-3 pr-0"
            style="background-color: #d1dcea"
        >
            <v-col cols="12" class="pa-0">
                <v-row class="ma-2">
                    <v-col class="text-list text-left px-0 py-1" style="margin-right: 20px; max-width:10.5%">
                        <small>Data do pagamento</small><br />
                        <b><span style="font-size: 18px">{{ dadosPagamento.data_pagamento | formatDate}}</span></b>
                    </v-col>
                    <v-col class="text-list text-left px-0 py-2" style="max-width:17.5%">
                        <b><span>{{dadosPagamento.oper_nome}}</span></b><br />
                        <span>{{dadosPagamento.prest_nome}}</span>
                    </v-col>
                    <v-col class="text-list text-right px-0 py-2" style="max-width:13.5%">
                        <small>Vl. informado (R$):</small><br />
                        <b><span>{{dadosPagamento.valor_informado | formatPrice }}</span></b>
                    </v-col>
                    <v-col class="text-list text-right px-0 py-2" style="max-width:13.5%">
                        <small>Vl. lib. de produção (R$):</small><br />
                        <b><span style="color: rgb(50, 184, 139)">{{dadosPagamento.valor_liberado | formatPrice }}</span></b>
                    </v-col>
                    <v-col class="text-list text-right px-0 py-2" style="max-width:9.5%">
                        <small>Vl. glosado (R$):</small><br />
                        <b><span style="color: red">{{ dadosPagamento.valor_glosado | formatPrice }}</span></b>
                    </v-col>
                    <v-col class="text-list text-right px-0 py-2" style="max-width:10.5%">
                        <small>Glosa mantida (R$):</small><br />
                        <b><span style="color: red">{{ dadosPagamento.valor_glosa_mantida | formatPrice }}</span></b>
                    </v-col>
                    <v-col class="text-list text-right px-0 py-2" style="max-width:10.5%">
                        <small>Vl. recursado (R$):</small><br />
                        <b><span style="color: rgb(50, 184, 139)">{{dadosPagamento.valor_recursado | formatPrice }}</span></b>
                    </v-col>
                    <v-col class="text-list text-right px-0 py-2" style="max-width:9.5%">
                        <small>Vl. acatado (R$):</small><br />
                        <b><span style="color: red">{{ dadosPagamento.valor_acatado | formatPrice }}</span></b>
                    </v-col>
                    <v-col style="max-width:5px"></v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-tabs v-model="tab" class="elevation-0 px-0">
        <v-tab href="#tab-glosa-regular"
            :disabled="dadosPagamento.qtde_lotes_regular == 0"
            @click="tab='tab-glosa-regular', filterList({...initialFilterData}, 1, 0)"
        >GLOSA REGULAR</v-tab>
        <v-tab  href="#tab-glosa-mantida"
            :disabled="dadosPagamento.qtde_lotes_mantida == 0"
            @click="filterList({...initialFilterData}, 1, 10)"
        >GLOSA MANTIDA</v-tab>
        <v-tab href="#tab-anexo" v-if="parametrizacao && parametrizacao.RG_ENVIO_ANEXO" @click="filterAnexoList()">ANEXOS</v-tab>
        <v-tabs-items v-model="tab">
            <v-tab-item value="tab-glosa-regular">
            <AcompanhamentoFilter
                        :dadosPagamento="dadosPagamento"
                        :envio_manual="envio_manual"
                        :estadoList="estadoList"                
                        :exibirNivelGuia="exibirNivelGuia"
                        :filterData="filterData"
                        :filterList="(formData)=>filterList(formData, 1, 0)"
                        :ident_operadora="identificadorPrestadoresList"
                        :openModal="()=> showProtocoloEnvioRecursoDlg = true"
                        :protocolo_pagamento="protocolo_pagamento"
                        :tipo_protocolo="tipo_protocolo"
                        :parametrizacao="parametrizacao"
                        :numLotesList="numLotesList"
                        :numGuiasList="numGuiasList"
                        :protocolosFaturadosList="protocolosFaturadosList"
                        :protocolosDemonstradosList="protocolosDemonstradosList"
                        :protocolosEnvioRecursoList="protocolosEnvioRecursoList"
                        :datasEnvioRecursoList="datasEnvioRecursoList"
                        :beneficiariosList="beneficiariosList"
                    />                   
                    <AcompanhamentoList
                        :dadosPagamento="dadosPagamento"
                        :envio_manual="envio_manual"
                        :parametrizacao="parametrizacao"
                        :estadoList="estadoList" 
                        :exibirNivelGuia="exibirNivelGuia"
                        :filterData="filterData"
                        :filterAnexoData="filterAnexoData"
                        :filterList="(formData, page)=>filterList(formData, page, 0)"
                        :filterAnexoList="(formData)=>filterAnexoList(formData, 1)"
                        :list="list"
                        :pagination="pagination"
                        :protocolo_pagamento="protocolo_pagamento"
                        :tipo_protocolo="tipo_protocolo"
                    />
            </v-tab-item>
            <v-tab-item value="tab-glosa-mantida">
            <AcompanhamentoFilter
                        :dadosPagamento="dadosPagamento"
                        :envio_manual="envio_manual"
                        :estadoList="estadoList"                
                        :exibirNivelGuia="exibirNivelGuia"
                        :filterData="filterData"
                        :filterList="(formData)=>filterList(formData, 1, 10)"
                        :ident_operadora="identificadorPrestadoresList"
                        :openModal="()=> showProtocoloEnvioRecursoDlg = true"
                        :protocolo_pagamento="protocolo_pagamento"
                        :tipo_protocolo="tipo_protocolo"
                        :parametrizacao="parametrizacao"
                        :numLotesList="numLotesList"
                        :numGuiasList="numGuiasList"
                        :protocolosFaturadosList="protocolosFaturadosList"
                        :protocolosDemonstradosList="protocolosDemonstradosList"
                        :protocolosEnvioRecursoList="protocolosEnvioRecursoList"
                        :datasEnvioRecursoList="datasEnvioRecursoList"
                        :beneficiariosList="beneficiariosList"
                    />                   
                    <AcompanhamentoList
                        :dadosPagamento="dadosPagamento"
                        :envio_manual="envio_manual"
                        :parametrizacao="parametrizacao"
                        :estadoList="estadoList" 
                        :exibirNivelGuia="exibirNivelGuia"
                        :filterData="filterData"
                        :filterAnexoData="filterAnexoData"
                        :filterList="(formData, page)=>filterList(formData, page, 10)"
                        :filterAnexoList="(formData)=>filterAnexoList(formData, 1)"
                        :list="list"
                        :pagination="pagination"
                        :protocolo_pagamento="protocolo_pagamento"
                        :tipo_protocolo="tipo_protocolo"
                    />
            </v-tab-item>
            <v-tab-item value="tab-anexo">
                <AcompanhamentoAnexosFilter
                    :dadosPagamento="dadosPagamento"
                    :estadoList="estadoAnexosList"  
                    :filterData="filterAnexoData"
                    :filterList="(formData)=>filterAnexoList(formData, 1)"
                    :ident_operadora="identificadorPrestadoresList"
                    :numGuiasList="numGuiasList"
                    :numLotesList="numLotesList"
                    :protocolosFaturadosList="protocolosFaturadosList"
                    :parametrizacao="parametrizacao"
                    :procedimentosList="procedimentosList"
                    :protocolo_pagamento="protocolo_pagamento"
                />    
                <AcompanhamentoAnexosList
                    :dadosPagamento="dadosPagamento"
                    :envio_manual="envio_manual"
                    :parametrizacao="parametrizacao"
                    :estadoList="estadoAnexosList" 
                    :exibirNivelGuia="exibirNivelGuia"
                    :filterData="filterAnexoData"
                    :filterList="(formData, page)=>filterAnexoList(formData, page)"
                    :list="anexosList"
                    :pagination="paginationAnexo"
                    :protocolo_pagamento="protocolo_pagamento"
                    :tipo_protocolo="tipo_protocolo"
                />
            </v-tab-item>
        </v-tabs-items>
        </v-tabs>
        <!-- <v-row wrap class="ma-0 px-0">
            <v-col class="col-xs-12 col-sm-12 col-md-12 pa-0">
                <AcompanhamentoFilter
                    :dadosPagamento="dadosPagamento"
                    :envio_manual="envio_manual"
                    :estadoList="estadoList"                
                    :exibirNivelGuia="exibirNivelGuia"
                    :filterData="filterData"
                    :filterList="(formData)=>filterList(formData, 1)"
                    :ident_operadora="identificadorPrestadoresList"
                    :openModal="()=> showProtocoloEnvioRecursoDlg = true"
                    :protocolo_pagamento="protocolo_pagamento"
                    :tipo_protocolo="tipo_protocolo"
                    :parametrizacao="parametrizacao"
                    :numLotesList="numLotesList"
                />                   
                <AcompanhamentoList
                    :dadosPagamento="dadosPagamento"
                    :envio_manual="envio_manual"
                    :parametrizacao="parametrizacao"
                    :estadoList="estadoList" 
                    :exibirNivelGuia="exibirNivelGuia"
                    :filterData="filterData"
                    :filterList="(formData, page)=>filterList(formData, page)"
                    :list="list"
                    :pagination="pagination"
                    :protocolo_pagamento="protocolo_pagamento"
                    :tipo_protocolo="tipo_protocolo"
                />
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
import AcompanhamentoAnexosList from "@/components/recebiveis/acompanhamento_de_envio/AcompanhamentoAnexosList";
import AcompanhamentoAnexosFilter from "@/components/recebiveis/acompanhamento_de_envio/AcompanhamentoAnexosFilter";
import AcompanhamentoList from "@/components/recebiveis/acompanhamento_de_envio/AcompanhamentoList";
import AcompanhamentoFilter from "@/components/recebiveis/acompanhamento_de_envio/AcompanhamentoFilter";
import { mapActions, mapState } from 'vuex';
export default {
    components: {
        AcompanhamentoAnexosFilter,
        AcompanhamentoAnexosList,
        AcompanhamentoFilter,
        AcompanhamentoList
    },
  data(){
      return{
            acoesList: {
                lotes: "getlotesrecursados",//"getstatusenviolotes" ,           Usar esse
                guias: "getguiasrecursoglosa",//"getguiasrecursadas" 
                itens: "getitensrecursoglosa" ,
            },
            pagination: {
                limit: 20,
                offset: 1,
                current_page: 1,
            },
            paginationAnexo: {
                limit: 20,
                offset: 1,
                current_page: 1
            },
            parametrizacao: {},
            showList: true,
            list:[],
            anexosList:[],
            envio_manual: null,
            estadoList: [
                { id: null, descricao: "Selecione", color: null },
                { id: 1, descricao: 'Upload finalizado', color: '#C4C4C4', class: 'icon-size' },
                { id: 2, descricao: 'Em Transmissão', color: 'warning'},
                { id: 4, descricao: 'Transmissão parcial com crítica', color: '#A42B0A'}, //color: '#4A4A4A'},
                { id: -1, descricao: 'Transmissão com crítica', color: '#A42B0A'},
                { id: 5, descricao: 'Aguardando conclusão na operadora', color: '#9154CD'}, //color: '#4A4A4A'},
                { id: 3, descricao: 'Concluído', color: '#32B88B'},
                // { id: 42, descricao: 'Acatado', color: 'primary'}
            ],
            estadoAnexosList: [
                { id: null, descricao: "Selecione", color: '' },
                { id: 0, descricao: 'Aguardando liberação', color: '#c4c4c4', class: 'icon-size' },
                { id: 1, descricao: 'Em processamento', color: '#4a4a4a', class: 'icon-size' },
                { id: 2, descricao: 'Em Transmissão', color: 'warning'},
                { id: -1, descricao: 'Transmissão com crítica', color: '#A42B0A'},
                { id: 3, descricao: 'Concluído', color: '#32B88B'},
            ],
            exibirNivelGuia: true,
            protocolo_pagamento: null,
            procedimentosList:[],
            dadosPagamento: {},
            pagamentoId: null,
            paramId: null,
            ident_operadora: [],
            identificacaoPrestadorGuias: [],
            identificadorPrestadoresList: [],
            valor_glosado_total: 0,
            initialFilterData: {
                identificacao_prestador: null,
                tipo_consulta: 'lotes',
                estado: null
            },
            filterData: {
                identificacao_prestador: null,
                tipo_consulta: 'lotes',
                estado: null
            },
            filterAnexoData: {
                status_envio: null,
                identificador_prestador: null,
                codigo_procedimento: null,
                pagamento_id: null,
                recurso_lote_id: null,
                recurso_guia_id: null,
                recurso_item_id: null,
                estado: null
            },
            tab: "tab-glosa-regular",
            tipo_protocolo: null,
            numLotesList: null,
            numGuiasList: null,
            protocolosFaturadosList: [],
            protocolosDemonstradosList: [],
            protocolosEnvioRecursoList: [],
            datasEnvioRecursoList: [],
            beneficiariosList:[]
        }
    },
    computed: {
        ...mapState({
            grupoEconomico: (state) => state.permissions.grupoEconomico,            
        }),
    },
    mounted() {
        this.prestadores = this.$store.getters[ "permissions/getPrestadoresByGeco"]();
        this.pagamentoId = this.$route.params.id
        this.getRecursoGlosa(this.pagamentoId)
        this.getLotesByPagamento(this.pagamentoId)
    },
    methods: {
        ...mapActions({
            getDocumentPost: "documents/getDocumentPost",
        }),
        getRecursoGlosa(pagamento_id) {
            this.$store.commit("showLoader", { circle: true });
            let payload = { grupo_economico: this.grupoEconomico, pagamento_id }
            let obj = { query:[ {modulo: 'Recebiveis', acao: 'getacompanhamentorecursoglosa', payload: payload} ], noLoader: true }
            this.$store.dispatch("request/doRequest", obj, {root: true}).then(response => {
                if(!response || response.isAxiosError || response.erros.length) {
                    this.$store.commit("hideLoader");
                    return
                }
                
                this.dadosPagamento = response
                this.tab = this.dadosPagamento.qtde_lotes_regular > 0? "tab-glosa-regular" : (this.dadosPagamento.qtde_lotes_mantida > 0? "tab-glosa-mantida" : null);
                this.envio_manual = response.envio_manual;
                this.identificadorPrestadoresList = response.identificador_prestador
                let { prestador_id, operadora_ans_id } = response
                let opts = {
                    query: [
                        {
                            Modulo: "Portal",
                            Acao: "getparametrizacoes",
                            Payload: {
                                grupo_economico: this.grupoEconomico,
                                prestador_id,
                                operadora_ans_id
                            },
                        },
                    ],
                    };

                this.$store.dispatch("request/doRequest", opts).then((resp) => {
                    //let { RG_TransmissaoWS, RG_ENVIORECURSO, RG_ENVIOEMAIL, RG_ENVIORECURSO_DIGITACAO } = resp.parametros
                    this.parametrizacao = resp.parametros
                    this.envio_manual = this.dadosPagamento.envio_manual;
                    // !( RG_TransmissaoWS || RG_ENVIORECURSO || RG_ENVIOEMAIL || RG_ENVIORECURSO_DIGITACAO );
                });
                   
            })
            
        },
        getLotesByPagamento(pagamento_id) {
            let payload = { grupo_economico: this.grupoEconomico, pagamento_id }
            let obj = { query:[ {modulo: 'Recebiveis', acao: 'getlotesbyidpagamento', payload} ] }
            this.$store.dispatch("request/doRequest", obj, {root: true}).then(response => {
                if(!response || response.isAxiosError || (response.erros && response.erros.length)) {
                    this.$store.commit("hideLoader");
                    return
                }
                this.numLotesList = response.dados
                this.numLotesList.unshift({id: null, descricao: "Selecione"})

                this.numGuiasList = response.numero_guias_list
                if(response.numero_guias_list.length>0)
                    this.numGuiasList.unshift({id: null, descricao: "Selecione"})

                this.protocolosFaturadosList = response.protocolos_faturados_list
                if(response.protocolos_faturados_list.length>0)
                    this.protocolosFaturadosList.unshift({id: null, descricao: "Selecione"})
                this.protocolosDemonstradosList = response.protocolos_demonstrados_list
                if(response.protocolos_demonstrados_list.length>0)
                    this.protocolosDemonstradosList.unshift({id: null, descricao: "Selecione"})

                this.protocolosEnvioRecursoList = response.protocolos_enviorecurso_list
                if(response.protocolos_enviorecurso_list.length>0)
                    this.protocolosEnvioRecursoList.unshift({id: null, descricao: "Selecione"})

                this.datasEnvioRecursoList = response.datas_enviorecurso_list
                if(response.datas_enviorecurso_list.length>0)
                    this.datasEnvioRecursoList.unshift({id: null, descricao: "Selecione"})


                this.beneficiariosList = response.beneficiarios_list
                if(response.beneficiarios_list.length>0)
                    this.beneficiariosList.unshift({id: null, descricao: "Selecione"})

                this.procedimentosList = response.codigos_procedimento
                this.procedimentosList = this.procedimentosList.filter(item => item.id != null).map(item => item ={id: item.id, descricao: item.id +' - ' + (item.descricao!=null?item.descricao: '')})
                this.procedimentosList.unshift({id: null, descricao: "Selecione"})

                return
            })
        },        
        filterList(formData, page, tipoPagto) {
            this.$nextTick();
            if(tipoPagto == null){
                switch(this.tab){
                    case "tab-glosa-regular":
                        tipoPagto = 0
                        break;
                    case "tab-glosa-mantida":
                        tipoPagto = 10
                        break;
                    default:
                        tipoPagto = null
                }
            }
            console.log("filterList", tipoPagto);
            this.pagination.offset = page? page : 1
            this.filterData = formData? formData : this.filterData
            this.filterData.tipo_pagamento = tipoPagto
            let acao = this.acoesList[this.filterData.tipo_consulta]
            if(this.filterData.tipo_consulta == 'lotes') {
                this.filterData.status = formData.status_envio
            }
            let payload = Object.assign({grupo_economico: this.grupoEconomico, ...this.filterData, ...this.pagination})
            payload.pagamento_id = this.pagamentoId
            let obj = {query:[ {modulo: 'Recebiveis', acao, payload}]}
            this.$store.dispatch("request/doRequest", obj, {root: true}).then(response => {
                if (!response || response.isAxiosError || response.erros.length) {

                    this.$store.commit("hideLoader");
                    return;
                }

                this.list = response.dados

                if(formData.tipo_consulta == 'lotes'){
                    
                    let {data_envio, numero_protocolo_envio, tipo_protocolo} = response
                    this.protocolo_pagamento = (!!data_envio || !!numero_protocolo_envio)? { data_envio, numero_protocolo_envio} : null
                    this.tipo_protocolo = tipo_protocolo
                    // if(this.list.length <= 0 ){
                    //     this.tab = 1;
                    //     this.filterList({...this.initialFilterData}, 1, 10);
                    // }
                }
            
                this.exibirNivelGuia = this.list.filter(x => x.tem_guias_recursadas == true) != null ? true : false//this.list.findIndex(x=> x.tem_guias_recursadas == true) > -1
                this.pagination.current_page = response.current_page
                this.pagination.offset = response.current_page
                this.pagination.total_pages = response.total_pages
                this.valor_glosado_total = response.valor_glosado_total
                this.isValoresIguais = response.is_valor_igual ?response.is_valor_igual : false
            })
        },
        filterAnexoList(formData, page){
                this.paginationAnexo.offset = page? page : 1
                let filtro = formData? formData : this.filterAnexoData
                let acao = "getanexorecurso"
                let {prestador_id, operadora_ans_id, data_pagamento} = this.dadosPagamento
                let payload = Object.assign({grupo_economico: this.grupoEconomico, ...filtro, ...this.paginationAnexo,
                prestador_id, operadora_ans_id, data_pagamento})
                payload.pagamento_id = this.pagamentoId
                let obj = {query:[ {modulo: 'Recebiveis', acao, payload}]}
                this.$store.dispatch("request/doRequest", obj, {root: true}).then(response => {
                    if (!response || response.isAxiosError || response.erros.length) {
    
                        this.$store.commit("hideLoader");
                        return;
                    }
                    this.anexosList = response.dados
                    this.paginationAnexo.current_page = response.current_page
                    this.paginationAnexo.offset = response.current_page
                    this.paginationAnexo.total_pages = response.total_pages
                    setTimeout(() => {
                        if(this.tab != "tab-anexo"){
                            this.tab = "tab-anexo";
                        }
                    this.filterAnexoData = {...filtro};
                    }, 600);
                })
            
        },
    },
    
}

</script>
<style lang="scss">
    .icon_size{
        font-size: 15px !important;
    }
</style>